'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _require = require('./symbols'),
    func = _require.func;

var stringPredicates = _defineProperty({
  empty: function empty(value) {
    return value === '';
  },
  nonEmpty: function nonEmpty(value) {
    return value !== '';
  }
}, func, {
  is: function is(fn) {
    return fn;
  },
  eq: function eq(v) {
    return function (value) {
      return value === v;
    };
  },
  length: function length(v) {
    return function (value) {
      return value.length === v;
    };
  },
  minLength: function minLength(v) {
    return function (value) {
      return value.length >= v;
    };
  },
  maxLength: function maxLength(v) {
    return function (value) {
      return value.length <= v;
    };
  },
  matches: function matches(v) {
    return function (value) {
      return v.test(value);
    };
  },
  startsWith: function startsWith(v) {
    return function (value) {
      return value.startsWith(v);
    };
  },
  endsWith: function endsWith(v) {
    return function (value) {
      return value.endsWith(v);
    };
  }
});

module.exports = {
  predicates: stringPredicates,
  validator: function validator(value) {
    return typeof value === 'string';
  }
};